import PhotoEntity from "../models/photo-entity"

const PHOTOS_PER_REQUEST = 1

class PhotosRepository {
  constructor({ service, storage }) {
    this.service = service
    this.storage = storage
  }

  _insertIntoStorage({ photoId, photos }) {
    const photoEntityMap = {}
    Object.entries(photos).forEach(([key, photo]) => {
      if (photo === null) return
      photoEntityMap[key] = PhotoEntity.fromJson(photo)
    })

    this.storage.insert(photoEntityMap, photoId)
  }

  loadFromStorage({ photoId, direction }) {
    if (direction === "backward") {
      return this.storage.getPreviousOrNull(photoId)
    }
    if (direction === "forward") {
      return this.storage.getNextOrNull(photoId)
    }
    return null
  }

  async loadFromNetwork({ photoId, direction }) {
    const { photos } = await this.service.get(photoId, {
      backward: direction === "backward" ? 1 : 0,
      forward: direction === "forward" ? 1 : 0,
    })

    // Convert JSON photos to PhotoEntity instances
    const photoEntities = {}
    Object.entries(photos).forEach(([key, photoJson]) => {
      if (photoJson !== null) {
        photoEntities[key] = PhotoEntity.fromJson(photoJson)
      } else {
        photoEntities[key] = null
      }
    })

    this.storage.insert(photoEntities, photoId)
    return this.loadFromStorage({ photoId, direction })
  }

  async load({ photoId, direction }) {
    // Try cache first
    const requestedPhoto = this.loadFromStorage({ photoId, direction })
    if (requestedPhoto !== null) return requestedPhoto

    // Fall back to network
    return this.loadFromNetwork({ photoId, direction })
  }

  async preload(photoId) {
    const hasBackward = this.loadFromStorage({ photoId, direction: "backward" }) !== null
    const hasForward = this.loadFromStorage({ photoId, direction: "forward" }) !== null

    if (hasBackward && hasForward) return

    const { photos } = await this.service.get(photoId, {
      backward: hasBackward ? 0 : 1,
      forward: hasForward ? 0 : 1,
    })

    // Convert JSON photos to PhotoEntity instances
    const photoEntities = {}
    Object.entries(photos).forEach(([key, photoJson]) => {
      if (photoJson !== null) {
        photoEntities[key] = PhotoEntity.fromJson(photoJson)
      } else {
        photoEntities[key] = null
      }
    })

    this.storage.insert(photoEntities, photoId)
  }

  updatePhotoInStorage(photo) {
    this.storage.update(photo)
  }

  vote(photoId, rating) {
    return this.service.vote(photoId, rating)
  }
}

export default PhotosRepository
